var zoomEnable = !0;
$(document).ready(function () {
  $(document).on("click", "#enableZoom", function (e) {
    e.preventDefault(),
      zoomEnable
        ? ($(".ZoomContainer").remove(),
          $("#product-featured-image").ezPlus({
            zoomType: "lens",
            lensShape: "square",
            borderSize: 0,
            lensSize: 400,
            scrollZoom: !0,
            containLensZoom: !0,
            cursor: "pointer",
            zoomEnabled: !0,
          }),
          (zoomEnable = !1),
          $("#txtEnableZoom").text("Off"))
        : ($("#product-featured-image").ezPlus({ zoomEnabled: !1 }),
          (zoomEnable = !0),
          $(".ZoomContainer").remove(),
          $("#txtEnableZoom").text("On"));
  });

  // Event listener to show .ZoomContainer on mouse enter
  $(document).on("mouseenter", ".main-image", function () {
    $(".ZoomContainer").css("display", "block");
  });

  // Event listener to hide .ZoomContainer when mouse leaves
  $(document).on("mouseleave", ".main-image", function () {
    $(".ZoomContainer").css("display", "none");
  });

  // Ensure the zoom container is always shown/hidden correctly
  $(document).on("mouseenter", ".ZoomContainer", function () {
    $(this).css("display", "block");
  });

  $(document).on("mouseleave", ".ZoomContainer", function () {
    $(this).css("display", "none");
  });
});
//# sourceMappingURL=/s/files/1/0419/7416/9759/t/27/assets/zoom-initialize.js.map?v=1700083644
